<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Deuda de Clientes</strong>
          </div>
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"
                  :state="clienteValido"/>
                <b-form-invalid-feedback id="clienteFeedback">
                  {{ clienteInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="agruparClientes"
                  v-model="agruparClientes"
                  :value="Boolean(true)"
                  :unchecked-value="Boolean(false)">
                  Agrupar Deuda por Cliente
              </b-form-checkbox>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'ABM',
  components: {
    // appRptButton: RptButtons,
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',

      cliente: null,
      agruparClientes: false,

      labelCols: 1,
    }
  },
  computed: {
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      }

      let params = {
        clienteId
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('cuentacorrienteclientes/getRptDeuda', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let resumenDeudaRpt = this.$store.getters['cuentacorrienteclientes/rptDeuda'];

            if (resumenDeudaRpt) {
              if (resumenDeudaRpt.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              if ((/true/i).test(this.agruparClientes)) {
                this.exportXLSResumenDeudaClientesAgrupado(resumenDeudaRpt);
              } else {
                this.exportXLSResumenDeudaClientes(resumenDeudaRpt);
              }
            } else {
              this.showErrorMsj('No hay datos para exportar.')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {

    },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
